import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeSpaces',
  standalone: false
})
export class RemoveSpacesPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return value ? value.replace(/\s/g, '') : '';
  }
}
